import { getAccessToken } from "./lib/supabase-client";

export interface CreditsInfo {
  remaining: number;
  freeLeft: number;
  paidLeft: number;
}

export async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = await getAccessToken();
  if (!token) throw new Error("Not authenticated");
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export async function getCreditsInfo(): Promise<CreditsInfo> {
  const headers = await getAuthHeaders();
  const res = await fetch("/api/credits", { headers });
  if (!res.ok) {
    throw new Error("Failed to fetch credits");
  }
  return res.json();
}
